<template>
    <b-card no-body>

        <AddRemark ref="add_remark_modal" />

        <b-card-header>
            <b-row align-v="center">
                <b-col cols="6">
                    <h3 class="mb-0">
                        Remarks
                    </h3>
                </b-col>
            </b-row>
        </b-card-header>
        <div class="p-4">
           <span class="text-muted">This user don't have any remarks yet</span>
           <div class="text-center">
                <el-button type="text" @click="$refs.add_remark_modal.viewAddRemark()" disabled>+ Add Remarks</el-button>
           </div>
        </div>
    </b-card>
</template>
<script>
import { Card, Button } from 'element-ui'
import AddRemark from '@/views/CustomerProfile/Modals/AddRemark'

export default {
    name: 'remarks',
    components: {
        AddRemark,
        [Card.name]: Card,
        [Button.name]: Button,
    },
}
</script>